import React, { ReactElement } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  actions as ElearningPlayerActions,
  ElearningPlayerStateType,
} from '@/components/Player/modules/reducers/elearningPlayer';

import HelperView from './HelperView';

import './Helper.scss';
import { FaqType, HelperType } from '@/modules/types/helper';

const Helper = (): ReactElement => {
  const dispatch = useDispatch();

  const {
    isVisibleHelper,
    content: { helperContent, helperFaq },
  }: ElearningPlayerStateType = useSelector(
    (state: { elearningPlayer: ElearningPlayerStateType }) =>
      state.elearningPlayer,
  );

  const closeHelperHandler = () => {
    dispatch({
      type: ElearningPlayerActions.closeHelper.type,
    });
  };

  return (
    <HelperView
      isVisible={isVisibleHelper}
      content={helperContent}
      faq={helperFaq}
      closeHelper={closeHelperHandler}
    />
  );
};

export default Helper;
